import {
  TASKLISTDETAIL_LOADING,
  GET_TASKLISTDETAIL,
  GET_TASKLISTDETAIL_SUCCESS,
  GET_TASKLISTDETAIL_FAIL,
  ADD_TASKLISTDETAIL_SUCCESS,
  ADD_TASKLISTDETAIL_FAIL,
  DELETE_TASKLISTDETAIL_SUCCESS,
  DELETE_TASKLISTDETAIL_FAIL,
  UPDATE_TASKLISTDETAIL_SUCCESS,
  UPDATE_TASKLISTDETAIL_FAIL,
  TASKLISTDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  taskListDetails: [],
  error: {},
};

const TaskListDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TASKLISTDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TASKLISTDETAIL:
          return {
            ...state,
            taskListDetails: action.payload.data,
            isTaskListDetailCreated: false,
            isTaskListDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TASKLISTDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_TASKLISTDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTaskListDetailCreated: false,
            isTaskListDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TASKLISTDETAIL: {
      return {
        ...state,
        isTaskListDetailCreated: false,
        loading: true,
      };
    }

    case TASKLISTDETAIL_LOADING: {
      return {
        ...state,
        isTaskListDetailCreated: false,
        loading: true,
      };
    }

    case ADD_TASKLISTDETAIL_SUCCESS:
      return {
        ...state,
        isTaskListDetailCreated: true,
        loading: false,
        taskListDetails: [action.payload.data, ...state.taskListDetails],
      };

    case ADD_TASKLISTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TASKLISTDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isTaskListDetailCreated: true,
        taskListDetails: state.taskListDetails.filter(
          taskListDetail => taskListDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TASKLISTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TASKLISTDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isTaskListDetailCreated: true,
        taskListDetails: state.taskListDetails.map(taskListDetail =>
          taskListDetail.id.toString() === action.payload.data.id.toString() ? { ...taskListDetail, ...action.payload.data } : taskListDetail
        ),
      };

    case UPDATE_TASKLISTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TASKLISTDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default TaskListDetail;